import axios from 'axios'
import { SERVER_URL, apiHeader } from '../config'

export const getAllPrices = async (lng: string) =>
    (await axios.post(`${SERVER_URL}/prices/all`, { lng }, apiHeader())).data
